import * as React from 'react';
const h = React.createElement;

export interface DividerProps {
  style?: React.CSSProperties;
  dashed?: boolean;
  className?: string;
}

const Divider: React.FC<DividerProps> = function Divider(props) {
  const { style, dashed, className = '' } = props;
  return h('hr', {
    className: `border-dark-700 my-4 ${dashed ? 'border-dashed' : 'border-solid'} ${className}`,
    style: style || {},
  });
};

export { Divider };
